



























































import BaseComponent from '@/components/base-component.vue';
import PrescriptionListFilters from '@/components/prescription/list/filters.vue';
import PrescriptionListTable from '@/components/prescription/list/table.vue';
import PrescriptionForm from '@/components/prescription/prescription-form.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import WhatsappButton from '@/components/UI/whatsapp-button.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { resetModalScroll } from '@/helpers/resetModalScroll';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { PrescricaoFiltroParmDTO, PrescricaoParmDTO } from '@/interfaces/prescription';
import PrescriptionModel from '@/models/prescription-model';
import router from '@/routes';
import * as service from '@/services/prescription';
import { getRedirectLinkOriginAndRemove } from '@/services/session-data';
import { PRESCRIPTION_REFRESH_TIME } from '@/settings/consts/prescription-params';
import { COPY, MODEL } from '@/settings/consts/prescriptions-types';
import { BehaviorSubject, empty } from 'rxjs';
import {
  catchError, debounceTime, skipWhile,
  switchMap, tap
} from 'rxjs/operators';
import Component from 'vue-class-component';
import { PRESCRIPTION_COPY_PATH, PRESCRIPTION_PATH } from '../routes';


@Component({
  components: {
    ListMessages,
    PrescriptionForm,
    PrescriptionListFilters,
    PrescriptionListTable,
    UiDatePicker,
    PermissionAuth,
    WhatsappButton,
    UiFilterContainer
  },
})
export default class Prescription extends BaseComponent {
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  public showFilterMenu: boolean = false;

  public selectedClientNovo: any = {};
  public selectedCompanyNova: any = {};  

  public search: any = null;
  public isVisualizing: boolean = false;
  public isToCancel: boolean = false;

  public today: string = '';
  public prescriptions: any[] = [];
  public prescriptionsToday: any[] = [];
  public item: PrescriptionModel = new PrescriptionModel();
  public copyItem: PrescriptionModel = new PrescriptionModel();
  public alter: boolean =  false;
  public idsAlter: number[] = [];
  public idReasonAlter: number = null;
  public presetDeliveryDates: [] = null;
  public deliveryDateDisabled = false;
  public oneDeliveryDateOnly: boolean = false;
  public idNotification = null;
  public linkOrigin = null;
  public requestPrescriptionsSubject$: BehaviorSubject<
    any
  > = new BehaviorSubject('initialize');
  public pagination: any = {};
  public totalPrescriptions: number = 0;
  public intervalId: any = null;

  private redirectCallback = null;
  public draft:PrescricaoParmDTO = null;

  public beforeMount(): void {
    this.registerRequestPrescriptions();
    this.setReloadInterval();
  }

  public destroyed(): void {
    this.clearReloadInterval();
  }

  refresh() {
    this.onFilter(this.search);
  }

  public onFilter(value): void {
    this.showFilterMenu = false;
    this.search = value;
    this.pagination.page = 1;
    if (this.search.sortBy) {
      this.pagination.descending = this.search.descending;
      this.pagination.sortBy = this.search.sortBy
    }
    this._load();
  }

  public onChangePagination(value): void {
    this.pagination = value;
    this._load();
  }

  public onVisualize(item: any): void {
    this.item = item;
    this.isVisualizing = true;
    this.formOpen = true;
    this.clearReloadInterval();
  }

  public openForm(item: any): void {
    this.item = item;
    this.isVisualizing = false;
    this.formOpen = true;
    this.clearReloadInterval();
  }

  public onSave(): void {
    this.closeForm();
    this._load();
  }

  public newItem(alter:boolean = false): void {
    this.item = new PrescriptionModel();
    this.isVisualizing = false;
    this.alter = alter;
    this.formOpen = true;
    this.clearReloadInterval();
  }

  public closeForm(): void {
    this.item = null;
    this.copyItem = null;
    this.alter = null;
    this.idReasonAlter = null;
    this.idsAlter = null;
    this.presetDeliveryDates = null;
    this.deliveryDateDisabled = false;
    this.oneDeliveryDateOnly = false;
    this.idNotification = null;
    this.linkOrigin = null;
    this.isVisualizing = false;
    this.isToCancel = false;
    this.formOpen = false;
    this.setReloadInterval();
    resetModalScroll('.input-section form');
    if (this.redirectCallback) {
      router.push(this.redirectCallback);
      this.redirectCallback = null;
    }
  }

  private _load(): void {
    if (this.search == null) {
      return;
    }
    let f = new PrescricaoFiltroParmDTO();
    f.update(this.pagination);
    f.idPaciente = this.search.patientId;
    f.idMedico = this.search.doctorId;
    f.idSiPro = this.search.idPrescription;
    f.idUnidade = !!this.search.hospitalUnit  ? this.search.hospitalUnit.id  : null;
    f.dataProducaoRealizada = this.search.productionDateDone;
    f.dataProducaoInicio = this.search.productionDate[0];
    f.dataProducaoFim = this.search.productionDate[1];
    f.dataEntregaRealizada = this.search.prescriptionDateDone;
    f.dataEntregaInicio = this.search.prescriptionDate[0];
    f.dataEntregaFim = this.search.prescriptionDate[1];
    f.dataCriacaoInicio = this.search.prescriptionCreatedDate[0];
    f.dataCriacaoFim = this.search.prescriptionCreatedDate[1];
    f.bolsaMulti = this.search.multi;
    f.statuses = this.search.prescriptionStatus;

    this.requestPrescriptionsSubject$.next(f);
  }

  private registerRequestPrescriptions(): void {
    const today = dateFormat(null, 'UNIX');
    this.requestPrescriptionsSubject$
      .pipe(
        skipWhile((val) => {
          return val === 'initialize';
        }),
        tap(() => {
          this.prescriptions = [];
          this.loading = true;
          this.error = false;
        }),
        debounceTime(1000),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {          
          return service.listPrescriptions(filter).pipe(
            catchError((err) => {
              this.prescriptions = [];
              this.loading = false;
              this.error = true;
              return empty();
            }),
          );
        }),
      )
      .subscribe(pag => {
        this.totalPrescriptions = Number(pag.totalElements);
        PaginationSyncDTO.update(this.pagination, pag);
        this.prescriptions = pag.content;
        this.loading = false;        
      }, error => {
        this.loading = false;
        this.error = true;
      });
  }

  private setReloadInterval(): void {
    this.intervalId = setInterval(() => {
      this._load();
    }, PRESCRIPTION_REFRESH_TIME);
  }

  private clearReloadInterval(): void {
    if (!!this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  public onPrescribeCopy(editable, item, idNotif) {
    this.copyItem = item;
    this.idNotification = idNotif;
    this.linkOrigin = getRedirectLinkOriginAndRemove();
    this.copyItem.tipoPrescricao = editable ? MODEL : COPY;
    this.newItem();

    setTimeout(() => {
      this.loader.start('Preparando a cópia ...');      
    }, 500);
  }

  public onNewPrescription() {
    this.idNotification = null;
    this.linkOrigin = null;
  }


  mounted() {
    this.prepareRedirectNew();
    this.prepareRedirect();
    this.prepareRedirectToCopyFromExternalLink();
    
  }

  prepareRedirect() {
    let idCp = this.$route.query.idCp ? this.$route.query.idCp.toString() : null;
    let idVw = this.$route.query.idVw ? this.$route.query.idVw.toString() : null;
    let callback = this.$route.query.callback;
    let idNotif = this.$route.query.idNotif;
    let cancel = this.$route.query.cnc;
    let validate = this.$route.query.vld;
    let editable = this.$route.query.editable === "true";    
    if (!idCp && !idVw) {
      return;
    }

    history.replaceState({}, null, PRESCRIPTION_PATH)
    setTimeout(() => {
      this.loader.start('Carregando item...');
      service.getPrescription(idCp ? idCp : idVw).subscribe(
        (res) => {
          this.loader.stop();
          if (callback) {
            this.redirectCallback = callback;
          }
          if (idVw) {
            if (validate == 'true') {
              this.openForm(res);
            } else {
              if (cancel == 'true') {
                this.isToCancel = true;
              }
              this.onVisualize(res);
            }
            return;
          }
          this.onPrescribeCopy(editable, res, idNotif);
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        },
      );      
    }, 100);
  }

  prepareRedirectNew() {
    let newPrescr = this.$route.query.new ? this.$route.query.new.toString() == "true" : false;    
    if (!newPrescr) {
      return;
    }
    let callback = this.$route.query.callback;
    let idUnidade = this.$route.query.idUni;
    let idPaciente = this.$route.query.idPac;
    let data = this.$route.query.dt;
    if (callback) {
      this.redirectCallback = callback;
    }

    history.replaceState({}, null, PRESCRIPTION_PATH)
    
    setTimeout(() => {
      if (idUnidade) {
        let draft = new PrescricaoParmDTO();
        draft.idUnidCliente = idUnidade ? new Number(idUnidade) : null;
        draft.idPaciente = idPaciente ? new Number(idPaciente) : null;
        this.draft = draft;
      }
      this.newItem();
      if (data) {
        this.item.dataPrescricao = [data.toString()]
      }
       
    }, 100);
  }

  prepareRedirectToCopyFromExternalLink() {
    if (this.$route.path != PRESCRIPTION_COPY_PATH) {
      return;
    }
    let uuid = this.$route.query.uuid ? this.$route.query.uuid.toString() : null;
    if (!uuid) {
      return;
    }

    history.replaceState({}, null, PRESCRIPTION_PATH)
    setTimeout(() => {
      this.loader.start('Carregando item...');
      service.getPrescriptionByUuid(uuid).subscribe(
        (res) => {
          this.loader.stop();
          this.onPrescribeCopy(true, res, null);
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        },
      );      
    }, 100);
  }

  onAlterPrescription(ids, dates, idReason, item) {
    this.copyItem = item;
    this.copyItem.tipoPrescricao = MODEL;
    this.idsAlter = ids;
    this.idReasonAlter = idReason;
    this.presetDeliveryDates = dates;
    if (dates && dates.length > 1) { 
      // Ao alterar mais de uma prescrição de uma vez, restringir alteração de datas
      this.deliveryDateDisabled = true;
      this.oneDeliveryDateOnly = false;
    } else {
      // Alteração de prescrição unica passa a permitir alteração de data
      this.deliveryDateDisabled = false;
      this.oneDeliveryDateOnly = true;
    }
    this.newItem(true);

    setTimeout(() => {
      this.loader.start('Preparando ...');      
    }, 500);
  }
}
